enum SCAN_STATE {
	NEW = 'NEW', // pending in line - will be running very soon
	PENDING = 'PENDING', // pending in line - will be running very soon
	RUNNING = 'RUNNING', // currently running, no results or csvs
	INGESTING = 'INGESTING', // results are ready, but none of csvs is ready
	GENERATING_CSV = 'GENERATING_CSV', // results are ready, but none of csvs is ready
	DONE = 'DONE', // scan is done, both csvs are ready
	FAILED = 'FAILED', // scan is failed
	CANCELING = 'CANCELING', // cancelling is in progress
	CANCELED = 'CANCELED', // cancelled in the past
	DONE_WITHOUT_CSV = 'DONE_WITHOUT_CSV', // no issues, with pages
	DONE_WITHOUT_PAGES_CSV = 'DONE_WITHOUT_PAGES_CSV', // no page, with issues
	INGESTED_WITHOUT_PAGES_CSV = 'INGESTED_WITHOUT_PAGES_CSV', // ask Dor
	FAILED_INGESTING = 'FAILED_INGESTING', // ingest failed
	DONE_WITHOUT_RESULTS = 'DONE_WITHOUT_RESULTS' // ingest didn't run, no issues/pages CSV generated
}

export { SCAN_STATE };
